import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export const SectionKategori = () => {
  const navigate = useNavigate();

  const categories = [
    {
      title: "TRAIL 7K",
      eventId: "PARADISO",
      image:
        "https://res.cloudinary.com/utmb-world/image/upload/q_auto/f_auto/c_fill,g_auto/if_w_gt_500/c_scale,w_500/if_end/v1//valholl/USHUAIA/HOME/PORTADA_HOME_114559b06d.jpg?_a=ATADJAA0",
      distance: "7 KM",
      elevation: "500 M+",
      flagOff: "06:00",
      cot: "3 Jam",
      date: "19th April",
      price: 100000,
      slug: "trail-7k",
    },
    {
      title: "TRAIL 15K",
      eventId: "PARADISO",
      image:
        "https://res.cloudinary.com/utmb-world/image/upload/q_auto/f_auto/c_fill,g_auto/if_w_gt_500/c_scale,w_500/if_end/v1//chianti/Races/Photos/Chianti_Ultra_Trail_Francesco_Mazzei_61_6189013412.jpg?_a=ATADJAA0",
      distance: "15 KM",
      elevation: "900 M+",
      flagOff: "05:30",
      cot: "5 Jam",
      date: "19th April",
      price: 200000,
      slug: "trail-15k",
    },
    {
      title: "TRAIL 30K",
      eventId: "PARADISO",
      image:
        "https://images.pexels.com/photos/6476783/pexels-photo-6476783.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      distance: "30 KM",
      elevation: "1500 M+",
      flagOff: "05:00",
      cot: "8 Jam",
      date: "19th April",
      price: 300000,
      slug: "trail-30k",
    },
  ];

  const handleRegister = (category) => {
    navigate(`/form/${category.slug}`, {
      state: {
        title: category.title,
        price: category.price,
        eventId: category.eventId,
      },
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section
      id="kategori"
      className="w-full min-h-screen py-20 text-cyan-600 text-center flex-col justify-center relative"
      style={{
        backgroundImage: "url('/bg/bghero5.jpg')",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-slate-400 bg-opacity-40"></div>

      <div className="relative z-1 container mx-auto px-4">
        <motion.h2
          className="text-xl sm:text-2xl md:text-3xl font-normal uppercase mb-2 text-white"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          KATEGORI
        </motion.h2>

        <motion.p
          className="text-4xl sm:text-5xl md:text-7xl font-black mx-auto mb-16 text-white"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
        >
          PERLOMBAAN
        </motion.p>

        <motion.div
          className="grid md:grid-cols-3 gap-8 z-1 relative"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {categories.map((category, index) => (
            <motion.div
              key={index}
              className="bg-gray-100 rounded-2xl shadow-md flex flex-col text-left relative overflow-hidden"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 * (index + 1) }}
              viewport={{ once: true }}
            >
              {/* <div
                className="relative w-full h-60 bg-cover bg-center rounded-t-lg"
                style={{ backgroundImage: `url(${category.image})` }}
              >
                <div className="absolute inset-0 bg-cyan-900 bg-opacity-40 z-0"></div>
              </div> */}

              <div className="px-4">
                <motion.h3
                  className="text-4xl sm:text-4xl md:text-4xl font-black m-6 uppercase text-center"
                  initial={{ opacity: 0, y: -15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {category.title}
                </motion.h3>

                <motion.div
                  className="w-full h-[2px] bg-cyan-600 mb-4"
                  initial={{ scaleX: 0 }}
                  whileInView={{ scaleX: 1 }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                  viewport={{ once: true }}
                  style={{ transformOrigin: "left" }}
                />

                <motion.div
                  className="flex justify-between items-start mb-4"
                  initial={{ opacity: 0, y: -15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  viewport={{ once: true }}
                >
                  <div>
                    <p className="text-sm font-medium text-cyan-800">JARAK</p>
                    <p className="text-base font-black text-cyan-600">
                      {category.distance}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-cyan-800">E.G.</p>
                    <p className="text-base font-black text-cyan-600">
                      {category.elevation}
                    </p>
                  </div>
                </motion.div>

                <motion.div
                  className="flex justify-between items-start mb-6"
                  initial={{ opacity: 0, y: -15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.6 }}
                  viewport={{ once: true }}
                >
                  <div>
                    <p className="text-sm font-medium text-cyan-800">
                      FLAG OFF
                    </p>
                    <p className="text-base font-black text-cyan-600">
                      {category.flagOff}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-cyan-800">COT</p>
                    <p className="text-base font-black text-cyan-600">
                      {category.cot}
                    </p>
                  </div>
                </motion.div>

                <ul className="text-left text-cyan-900 mt-4">
                  <motion.li
                    className="flex items-center mb-2"
                    initial={{ opacity: 0, y: -15 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                    viewport={{ once: true }}
                  >
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="mr-2 text-cyan-600"
                    />
                    <span>Tanggal: {category.date}</span>
                  </motion.li>
                </ul>

                <motion.div
                  className="text-center mt-4 mb-4"
                  initial={{ opacity: 0, y: -15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.8 }}
                  viewport={{ once: true }}
                >
                  <button
                    className="w-full py-3 bg-cyan-600 text-base font-semibold text-white rounded-xl hover:bg-cyan-800 my-4"
                    onClick={() => handleRegister(category)}
                  >
                    Daftar
                  </button>
                </motion.div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

